/*
 *
 * Home reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE_HOME,
  LOAD_HOME,
  LOAD_HOME_SUCCESS,
  LOAD_HOME_ERROR,
  CHANGE_HOME,
  CHANGE_HOME_SUCCESS,
  CHANGE_HOME_ERROR,
  DELETE_HOME,
  DELETE_HOME_SUCCESS,
  DELETE_HOME_ERROR,
} from './constants';

export const initialState = {
  loading: false,
  error: false,
  deleteSuccessful: false,
  homeList: false,
  homeData: false,
};

/* eslint-disable default-case, no-param-reassign */
const homeReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_HOME:
        return initialState;

      // LOAD
      case LOAD_HOME:
        draft.loading = true;
        draft.error = false;
        break;

      case LOAD_HOME_SUCCESS:
        draft.homeList = action.homeList;
        draft.loading = false;
        break;

      case LOAD_HOME_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // CHANGE/UPDATE
      case CHANGE_HOME:
        draft.homeData = { ...state.homeData, ...action.homeData };
        draft.loading = true;
        draft.error = false;
        break;

      case CHANGE_HOME_SUCCESS:
        draft.loading = false;
        const { homeData } = action;
        draft.homeData = homeData;

        // update single item in the list inside state
        let listData = draft.homeList.data;
        let index = draft.homeList.data.findIndex(
          po => po._id === homeData._id,
        );
        index !== -1
          ? (listData[index] = homeData)
          : listData.unshift(homeData);
        draft.homeList = { ...draft.homeList, data: listData };

        break;

      case CHANGE_HOME_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // DELETE
      case DELETE_HOME:
        draft.loading = true;
        draft.id = action.id;
        break;

      case DELETE_HOME_SUCCESS:
        draft.loading = false;
        draft.deleteSuccessful = true;
        break;
    }
  });

export default homeReducer;
